import React, { Component } from 'react';
import moment from 'moment';

export default class RemainderWorkRow extends Component {
  render() {
    
    const {RowData, openModalEdit} = this.props;
    return (
      <tr>
        <td>{RowData.Method}</td>
        <td className="text-center">{RowData.Email === '' ? '-' : RowData.Email}</td>
        <td className="text-center">{RowData.Mobile === '' ? '-' : RowData.Mobile}</td>
        <td>{moment(RowData.Time).format('lll')}</td>
        <td className="text-center">
          <button type="button" className="btn btn-4r btn-sm btn-primary" onClick={()=>openModalEdit(RowData)}><i className="icon-pencil"></i></button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/remainder/helper/component/RemainderWorkList/RemainderWorkRow.js